import React, { Component } from "react";
import {Link} from "react-router-dom";
import Select from "react-select";
import axios from 'axios';


import './Dealer.scss';
import MyContext from '../MyContext.jsx';
var customer_XHR={'abort' : ()=>{}};

var singleCustomer_DOM;
const imageUrl = '/file-name.jpg';


class Dealer extends Component {
   fileObj = [];
   fileArray = [];
   file_col = [];
   imagesArray = [];
   url = `${process.env.REACT_APP_SSS}/marketing/dealer`;

    constructor(props) {
      super(props);
      this.districtSelect = React.createRef();
      this.locationSelect = React.createRef();
    
      this.state = {
        file: [null],
        dealer_name : '',
        shop_category: 'NEW',
        shop_type: 'HUB',
        contact_person : '',
        contact_number : '',
        whatsapp_number : '',
        email_id : '',
        districts : [],
        district : '',
        locations : [],
        location : '',
        place : '',
        brands :[],
        selected_brand :[],
        category_id :[],
        category_list :[],
        sales_volume :[],
        monthly_sale_volume : '',
        shop_area:'',
        dealer_images : [],
        image: "",
        sid :'',
        dist : '',
        loc : '',
        sel : [],
        customer_id : '',
        img_idx : [],
        file : [],
        filesize : 0,
      }
      this.formChange = this.formChange.bind(this);
    }

    componentDidMount(){  
      singleCustomer_DOM = $(".single_customer_details").clone();
      var obj_this = this;
      //get categories and brands
      const url1 = `${process.env.REACT_APP_SSS}/api/get/categories/brands`;
      obj_this.context.loading(1);
      $.ajax({
        url : url1,
        data : {
          sid : this.context.user_details.sid
        },
        type : "GET"
      }).done(function(return_data){
        console.log(return_data);
        // return;
        if(return_data.status == "success"){
          obj_this.setState({
            districts : return_data.districts,
            category_list : return_data.categories,
            brands : return_data.brands,
          });
          obj_this.context.loading(0);
        }else{
          obj_this.context.loading(0);
          obj_this.props.history.replace("/");
        }
      }).fail(function(){
        obj_this.context.loading(0);
        alert("Network error");
      });

      $(".customer_suggestions_container").on("mousedown",".single_customer_details",function(){
        $(".customer_suggestions_container").empty().css("display","none");
        const customer_id = $(this).attr("customer_id");
        obj_this.context.loading(1);
        const url = `${process.env.REACT_APP_SSS}/api/dealer/details`;
        $.ajax({
          url : url,
          data : {
            sid : obj_this.context.user_details.sid,
            customer_id : customer_id
          },
          type : "POST"
        }).done(function(return_data){
          console.log(return_data);

          obj_this.setState({
            locations : return_data.locations,

          });
          var option = obj_this.state.districts.filter(item => item.value == return_data.dealer.district);
          var option1 = obj_this.state.locations.filter(item => item.value == return_data.dealer.location);
          console.log(return_data.sales);
          option = option[0]?option[0]:{};
          option1 = option1[0]?option1[0]:{};
          console.log(option1[0]?option1[0]:{});

          obj_this.setState({
            sales_volume : return_data.sales,
            selected_brand : return_data.brands,
            dealer_name : return_data.dealer.dealer_name,
            shop_category : return_data.dealer.dealer_type,
            contact_person : return_data.dealer.contact_person,
            contact_number : return_data.dealer.contact_no,
            place : return_data.dealer.place,
            monthly_sale_volume : return_data.dealer.monthly_sale_volume,
            shop_area:return_data.dealer.shop_area,
            shop_type : return_data.dealer.shop_type,
            district : option,
            whatsapp_number : return_data.dealer.whatsapp_no,
            email_id : return_data.dealer.email_id,
            location : option1,
            customer_id : customer_id,
            dealer_images : return_data.images,
            filesize:return_data.images.length,
          });

          obj_this.context.loading(0);
        });
      })

      $(".name").on("focusout",function(e){
        console.log(e.target);
        $(".customer_suggestions_container").empty().css("display","none");
      });
    }

    formChange(e){
      this.setState({
        [e.target.name] : e.target.value
      });
    }

    shopCategoryChange(e){
      // console.log(option);
      this.setState({
        shop_category : e.target.value
      }); 
    }

    shopTypeChange(e){
      // console.log(option);
      this.setState({
        shop_type : e.target.value
      }); 
    }

    brandChange(option){
      console.log(option);
      this.setState({
        selected_brand : option
      }); 
    }
  
    districtChange(option){
      this.setState({
        dist : option.value
      });
      this.setState({
        district : option
      });
      this.context.loading(1);
      const obj_this = this;
      const url = `${process.env.REACT_APP_SSS}/api/get/locations`;
      $.ajax({
        url : url,
        data : {
          sid : this.context.user_details.sid,

          district_id : option
        },
        type : "GET"
      }).done(function(return_data){
            console.log(return_data);

        if(return_data.status == "success"){
          obj_this.setState({
            locations : return_data.locations,
          });
          obj_this.context.loading(0);
        }else{
          obj_this.context.loading(0);
          obj_this.props.history.replace("/");
        }
      }).fail(function(){
        alert("Network error");
        obj_this.context.loading(0);
      });
    }

    locationChange(option){
      this.setState({
        loc : option.value
      });
      this.setState({
        location : option
      });
    }

    dealerChange(e){
      $(".customer_suggestions_container").empty();
      this.setState({
        [e.target.name] : e.target.value
      });
      
      if(!e.target.value){
        $(".customer_suggestions_container").empty().css("display","none");

        this.setState({
          contact_person : '',
          contact_number : '',
          whatsapp_number : '',
          email_id : '',
          district : '',
          location : '',
          place : '',
          selected_brand : [],
          monthly_sale_volume : '',
          shop_area :'',
          dealer_images : [],
          customer_id : '',
          sales_volume : [],
        });

          return;
      }
      // alert(e.target.value);
      if(!this.state.customer_id){
        $(".customer_suggestions_container").empty().css("display","none");

        this.setState({
        contact_person : '',
          contact_number : '',
          whatsapp_number : '',
          email_id : '',
          district : '',
          location : '',
          place : '',
          selected_brand : [],
          monthly_sale_volume : '',
          shop_area:'',
          dealer_images : [],
          customer_id : '',
          sales_volume : [],
        });

      }
      this.context.loading(1);
      const obj_this = this;
      const url = `${process.env.REACT_APP_SSS}/api/search/dealer/names`;
      customer_XHR.abort();
      customer_XHR = $.ajax({
        url : url,
        data : {
          sid : this.context.user_details.sid,
          dealer : e.target.value
        },
        type : "GET"
      }).done(function(return_data){
        if(return_data.dealers.length){
          for(var i=0;i<return_data.dealers.length;i++){
            var node = singleCustomer_DOM.clone();
            node.find(".customer_name").html(return_data.dealers[i]['dealer_name']);
            // node.find(".customer_phone_no").html(return_data.customers[i]['phone']);
            node.attr("customer_id",return_data.dealers[i]['id']);
            $(".customer_suggestions_container").append(node);
          }
          $(".customer_suggestions_container").css("display","block");
          obj_this.context.loading(0);
        }else{
          $(".customer_suggestions_container").css("display","none");
          obj_this.context.loading(0);
        }
      }).fail(function(){
        obj_this.context.loading(0);
      }); 
    }

    formSubmit(e){
      for (var i = 0; i < this.state.selected_brand.length; i++) {
        var j = this.state.selected_brand[i];
        this.state.sel.push(j.value);
      }
    
      e.preventDefault();
      var details = this.state;

      if(!details.district.value){
        this.districtSelect.current.focus();
        return;
      }
      if(!details.location.value){
        this.locationSelect.current.focus();
        return;
      }
      var sid =  this.context.user_details.sid;
      console.log(this.fileArray);   
      var obj_this = this;
      var fd = new FormData(document.querySelector('form'));
      for (let i = 0; i < this.state.image.length; i++) {
        fd.append("images[]", this.state.image[i]);
      }
      fd.append('indexes',this.state.img_idx);
      fd.append('selected_brand',this.state.sel);
      fd.append('dealer_id',this.state.customer_id);

      fd.append('sid',sid);

      const url = `${process.env.REACT_APP_SSS}/api/save/marketing/dealer/details`;
      obj_this.context.loading(1);
      axios.post(url,fd)
      .then(res =>{
        console.log(res.data);
        if(res.data.status == "success"){
          alert("Dealer inserted.");
          obj_this.context.loading(0);
          obj_this.props.history.replace('/dashboard');
        }
        else if(res.data.status == "update"){
              alert("Dealer updated.");
              obj_this.context.loading(0);
              obj_this.props.history.replace('/dashboard');
        }
        else if(res.data.status == "already"){
          alert("Dealer exists.");
          obj_this.context.loading(0);
          obj_this.props.history.replace('/dashboard');
        }
        else {
          alert("Network Error.");
          obj_this.context.loading(0);
        }
      });
    }    

    uploadMultipleFiles = (e) => {

      if(this.state.filesize+(e.target.files.length) <= 5) {
        for (let i = 0; i < e.target.files.length; i++) {      
          this.imagesArray.push(e.target.files[i]);
        }
        this.setState({
          image: this.imagesArray,
        });

        this.state.filesize = this.state.filesize+(e.target.files.length);
        this.fileObj.push(e.target.files);
        console.log(this.fileObj);

        for (let i = 0; i < this.fileObj[0].length; i++) {
            this.fileArray.push(URL.createObjectURL(this.fileObj[0][i]))
        }
        this.setState({ file: this.fileArray })
      }
      else {
        e.target.value = null;
        alert("Cant not upload more than 5 images");
      }
    }
    getComponent(e) {
      var name = e.target.getAttribute('name');
      if(name) {
        const url = `${process.env.REACT_APP_SSS}/api/delete/dealer/images`;
        customer_XHR.abort();
        customer_XHR = $.ajax({
          url : url,
          data : {
            sid : this.context.user_details.sid,
            id : name
          },
          type : "POST"
          }).done(function(return_data){
            if(return_data.status == "success"){
            }else{
              obj_this.context.loading(0);
            }
          });
          $(e.target).css({
            'display': 'none'
          });
          var n = document.getElementsByClassName(name);  
          $(n).css({
              'display': 'none'
          });
      } 
      else {
        this.imagesArray.splice(e.target.id, 1);
        var n = document.getElementsByClassName(e.target.id);
        $(e.target).css({
          'display': 'none'
        });
          $(n).css({
              'display': 'none'
          });
      }
      this.state.filesize = this.state.filesize-1;
    }
  render(){

  return (

    <MyContext.Consumer>
      {context => (
        <div className="new_marketing_dealer_container">
          <div className="page_header">
            
            <div className="page_title"><i className="fas fa-arrow-left" onClick={() => window.history.back()} style={{marginRight: '15px', cursor: 'pointer'}}></i> ADD / UPDATE DEALER</div>
          </div> 
          <form className="dealer_form"
            onSubmit={e => this.formSubmit(e)} encType="multipart/form-data" 
          >
            <div className="product_details_container blocks">
            <div className="customer_container">

              <div className="input_label_head">Dealer Details</div>
                <div className="input_label">Name of Dealer</div>
                  <input className="name input custom_input"
                    type="text"
                    name="dealer_name"
                    value={this.state.dealer_name}
                    onChange={e => this.dealerChange(e)}
                    required
                    autoComplete="off"
                  />
                     <div className="customer_suggestions_container">
                    <div className="single_customer_details">
                      <div className="customer_name"></div>
                      <div className="customer_phone_no"></div>
                    </div>
                  </div>
                  </div>
                <div className="input_radio_container">
                  <span>Shop Category : </span>
                    <div className="lead_type_radio_buttons">
                      <div className="label_radio_container">
                        <input type="radio" 
                          name="shop_category" 
                          value="NEW"  
                          checked={this.state.shop_category == 'NEW'} 
                          onChange={e => this.shopCategoryChange(e)}
                        />
                        <div>NEW</div>
                      </div>
                      <div className="label_radio_container">
                        <input type="radio" 
                          name="shop_category" 
                          value="EXISTING"
                          checked={this.state.shop_category == 'EXISTING'} 
                          onChange={e => this.shopCategoryChange(e)}
                        />
                        <div>EXISTING</div>
                      </div>
                    </div>
                </div>
                <div className="input_label">Contact Person</div>
                  <input className="name input custom_input"
                    type="text"
                    name="contact_person"
                    value={this.state.contact_person}
                    onChange={this.formChange}
                    required
                    autoComplete="off"
                  />
                <div className="input_label">Contact Number</div>
                  <input className="name input custom_input"
                    type="tel"
                    name="contact_number"
                    pattern="^[0]?[1-9][0-9]{9}$"
                    value={this.state.contact_number}
                    onChange={this.formChange}
                    required
                    autoComplete="off"
                  />
                <div className="input_label">Whatsapp Number</div>
                  <input className="name input custom_input"
                    type="tel"
                    name="whatsapp_number"
                    pattern="^[0]?[1-9][0-9]{9}$"
                    value={this.state.whatsapp_number}
                    onChange={this.formChange}
                    required
                    autoComplete="off"
                  />
                <div className="input_label">Email ID</div>
                  <input className="name input custom_input"
                    type="email"
                    name="email_id"
                    value={this.state.email_id}
                    onChange={this.formChange}
                    required
                    autoComplete="off"
                  />
                <div className="input_label">Wilayat</div>
                  <Select 
                    options={this.state.districts}  
                    value ={this.state.district}
                    name = "district"
                    className="district" 
                    ref={this.districtSelect}
                    onChange={e => this.districtChange(e)}
                    required
                  />  
                <div className="input_label">Location</div>
                  <Select 
                    options={this.state.locations}  
                    value ={this.state.location}
                    name = "location"
                    className="district" 
                    ref={this.locationSelect}
                    onChange={e => this.locationChange(e)}
                    required
                  />     
                <div className="input_label">Place</div>
                  <input className="name input custom_input"
                    type="text"
                    name="place"
                    value={this.state.place}
                    onChange={this.formChange}
                    required
                    autoComplete="off"
                  />
            </div>

            {this.state.customer_id?

            <div className="sale_volume_of_each_category blocks">
              <div className="input_label_head">Total Sale Volume Of Each Category</div>
                <div className="categories_container">
                  {this.state.sales_volume.map((item,idx) => (
                    <div className="single_category_container label_checkbox_container" key={idx}>
                      <label className="category_label label_for_checkbox">{item.category_name}</label>
                      <input className="category_id" type="hidden" name="category_id[]" value={item.id}/>

                      <input className="category_sale_volume" type="number" id={idx} name="total_sale_volume[]" data-value={item.id} defaultValue={item.total_sale_volume == 0 ? "":item.total_sale_volume} />
                    </div>
                  ))}
				        </div>
              </div>
              :
            <div className="sale_volume_of_each_category blocks">
              <div className="input_label_head">Total Sale Volume Of Each Category</div>
                <div className="categories_container">
                  {this.state.category_list.map((item,idx) => (
                    <div className="single_category_container label_checkbox_container" key={idx}>
                      <label className="category_label label_for_checkbox">{item.category_name}</label>
                      <input className="category_id" type="hidden" name="category_id[]" value={item.id}/>

                      <input className="category_sale_volume" type="number" id={idx} name="total_sale_volume[]" data-value={item.id} defaultValue=""/>
                    </div>
                  ))}
				        </div>
              </div>
              }
              <div className="product_details_container blocks">
              <div className="input_label_head">Other Details</div>
              <div className="input_radio_container">
                  <span>Shop Type : </span>
                    <div className="lead_type_radio_buttons">
                      <div className="label_radio_container">
                      <input type="radio" 
                          name="shop_type" 
                          value="HUB"  
                          checked={this.state.shop_type == 'HUB'} 
                          onChange={e => this.shopTypeChange(e)}
                        />
                        <div>HUB</div>
                      </div>
                      <div className="label_radio_container">
                      <input type="radio" 
                          name="shop_type" 
                          value="Normal Shop"
                          checked={this.state.shop_type == 'Normal Shop'} 
                          onChange={e => this.shopTypeChange(e)}
                        />
                        <div>Normal Shop</div>
                      </div>
                    </div>
                </div>
               
              <div className="input_label">Kalliyath Brands Used</div>
                <Select 
                  options={this.state.brands}  
                  value ={this.state.selected_brand}
                  isMulti={true}
                  ref={this.categorySelect}
                  onChange={e => this.brandChange(e)}
                  required
                />  
              <div className="input_label">Monthly Sales Volume</div>
                <input className="name input custom_input"
                  type="number"
                  name="monthly_sale_volume"
                  value={this.state.monthly_sale_volume}
                  onChange={this.formChange}
                  required
                  autoComplete="off"
                />
                 <div className="input_label">Shop Area in sq. ft</div>
                <input className="name input custom_input"
                  type="number"
                  name="shop_area"
                  value={this.state.shop_area}
                  onChange={this.formChange}
                  required
                  autoComplete="off"
                />
                <br></br>
                {this.state.customer_id?
                <span style={{marginTop: '10px'}}>
                <span className="form-group multi-preview" style={{marginTop: '10px'}}>
                {this.state.dealer_images.map((item,idx) => (
                  <span className="thumbnail">
                    <img src={`${this.url}/${item.image_src}`} alt="..." width="80px" key={idx} className={item.id}/>
                    <a>  <i class="far fa-times-circle" id={idx} name={item.id} onClick={(e) => this.getComponent(e)} > </i></a>
                  </span>
                ))}
            </span>

            <span className="form-group multi-preview" style={{marginTop: '10px'}}>
            {(this.fileArray || []).map((url,idx) => (
              <span className="thumbnail">
              <img src={url} className={idx}/>
              <a>  <i class="far fa-times-circle" id={idx} onClick={(e) => this.getComponent(e)} > </i></a>
              </span>
            ))}
            </span>
          </span>
            :

            <span className="form-group multi-preview" style={{marginTop: '10px'}}>

              { (this.fileArray || []).map((url,idx) => (
            
                <span className="thumbnail">

                <img src={url} className={idx}/>
                <a>  <i class="far fa-times-circle" id={idx} onClick={(e) => this.getComponent(e)} > </i></a>

                </span>

              ))}
        
          </span>
                
          }
              <div className="input_label">Upload Shop Images(Max 5)</div>
                <input className="file_upload"
                  type="file"
                  multiple
                  name="image[]"
                  id="files"
                  onChange={this.uploadMultipleFiles}
                  autoComplete="off"
                />
                
              </div>
              <button type="submit" className="submit_button"><i className="far fa-save"></i> Save</button>
            </form>           
        </div>
      )}
    </MyContext.Consumer>
  )}
}

export default Dealer;
Dealer.contextType = MyContext;
